// Module
var code = "<p>Set a timer in seconds for the visibility duration of your Thank you page, before the inactivity timer restart occurs.</p> <p><strong>Note:</strong> This timer cannot be less than 5 seconds. Please keep in mind that you should base your timer on the amount of content your Thank you page contains.</p> ";
// Exports
module.exports = code;